import { BreadcrumbItem } from '@/types/services';

export const CONTENTSET_TITLE = 'Unityでゲームを作ろう';
export const BASE_URL = '/hello-schoomy/unity-guide/s1';

export type TutorialItem = {
    code?: number;
    codeBackgroundColor?: string;
    title?: string;
    titleColor?: string;
    description?: string;
    descriptionColor?: string;
    topic?: string;
    topicBackgroundColor?: string;
    topicTextColor?: string;
    image?: ImageItem;
    borderColor?: string;
};

export type ImageItem = {
    imageName: string;
    widths?: { base: number; md?: number; lg?: number };
};

export type UnityGuideDataItem = {
    contentsUuid: string;
    level: string;
    title: string;
    subTitle: string;
    titleColor: string;
    backgroundColor: string;
    tutorials: TutorialItem[];
};

export const UNITY_GUIDE_DATA: readonly UnityGuideDataItem[] = [
    {
        contentsUuid: 'c97a3214',
        level: '01',
        title: 'スクーミーボードと加速度（角度）センサーコネクタの準備をする',
        subTitle:
            'スクーミーボードと角度センサーコネクターの使い方を知り、シリアルモニタに角度センサーのデータを表示します。',
        titleColor: '#3759A9',
        backgroundColor: '#C7DB4D',
        tutorials: [
            {
                title: 'スクーミーボードで取得した角度の値を元にゲームのキャラクターが動くように準備をします。',
                image: {
                    imageName: '8b810491.png',
                },
                borderColor: '#C7DB4D',
            },
            {
                image: {
                    imageName: '2f8ecf61.png',
                },
            },
            {
                topic: '設定方法',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'スクーミー IDE から、スクーミーブロックエディタを起動させます',
                image: {
                    imageName: 'ad356dd1.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: 'シリアルモニターに「y」の値が表示されるブロックコードを作成します',
                image: {
                    imageName: '369518df.png',
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: '「アップロード」をクリックし、スクーミーボードにプログラムを書き込みます',
                image: {
                    imageName: '69cc1a69.png',
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: 'シリアルモニターを表示させ「y」の値が表示されることを確認し、シリアルモニターを閉じます',
                image: {
                    imageName: '903951e2.png',
                },
            },
        ],
    },
    {
        contentsUuid: '0cd0092e',
        level: '02',
        title: 'Unityの環境設定をする',
        subTitle: 'Unityのダウンロードとインストールを行い、Unityを使えるようにするための環境設定をします。',
        titleColor: '#3759A9',
        backgroundColor: '#C7DB4D',
        tutorials: [
            {
                title: 'Unityで「あつめて！すいかばマン」を動かしましょう！',
                image: {
                    imageName: '6765854c.png',
                },
                borderColor: '#C7DB4D',
            },
            {
                topic: 'Unityの準備（Windowsの場合）',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: `①公式サイトにアクセスしUnityHubをインストールします`,
                description: `URL: https://unity.com/ja/download`,
                image: {
                    imageName: '5c12c712.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: 'UnityHubを起動させ、「インストール」をクリックします',
                image: {
                    imageName: '8c591ae7.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: '「エディターをインストール」をクリックします',
                image: {
                    imageName: '59ea1771.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: `「その他のバージョン」Unity（Unity 6.xでない方）→「インストール」をクリックします。
※文字が大きく、LTSがついているものを推奨 `,
                image: {
                    imageName: '147766d0.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#C7DB4D',
                title: `モジュール追加画面が開くので一番下までスクロールします`,
                image: {
                    imageName: '654bc37e.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 6,
                codeBackgroundColor: '#C7DB4D',
                title: `「日本語」のみにチェックを入れ、「インストール」をクリック`,
                image: {
                    imageName: '24f123b8.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 7,
                codeBackgroundColor: '#C7DB4D',
                title: `ダウンロードとインストールが始まるので5〜20分待ちます。
※環境にもよりますが５～２０分程度で完了します`,
                image: {
                    imageName: '0be03078.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 8,
                codeBackgroundColor: '#C7DB4D',
                title: `インストールが完了したら、「×」をクリックして閉じます`,
                image: {
                    imageName: '130ff2c2.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 9,
                codeBackgroundColor: '#C7DB4D',
                title: `「プロジェクト」をクリックします`,
                image: {
                    imageName: '426af412.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 10,
                codeBackgroundColor: '#C7DB4D',
                title: `プロジェクトの画面が表示されます`,
                image: {
                    imageName: '763f5ff7.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 11,
                codeBackgroundColor: '#C7DB4D',
                title: `プロジェクト画面で「New project」をクリックします`,
                image: {
                    imageName: 'd6e11897.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 12,
                codeBackgroundColor: '#C7DB4D',
                title: `「コア」を選択し、検索で「3D」と入力します。その後、「3D（Built-In Render Pipeline）」を選択し、「テンプレートをダウンロード」をクリックしてください`,
                image: {
                    imageName: '1fc931d6.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 13,
                codeBackgroundColor: '#C7DB4D',
                title: `「3D（Built-In Render Pipeline）」を選択して、「プロジェクトを作成」をクリックします`,
                description: 'プロジェクト名や保存場所は任意で変更してください',
                descriptionColor: '#ca2121ff',
                image: {
                    imageName: '5cabeda6.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 14,
                codeBackgroundColor: '#C7DB4D',
                title: `Unityエディターのソフトウェア利用規約への同意を行います。黄色枠の「□」をチェックして、「Accept and Continue」をクリックしてください`,
                image: {
                    imageName: 'd94f9c62.png',
                },
            },
            {
                topic: 'ビルド設定で.NET Frameworkを選択する',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: `File → Build Settings → Player Settings をクリックします`,
                image: {
                    imageName: '63e3f17e.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: `API互換性レベルを変更します
「Other Settings」の真ん中にある「Api Compatibility Level*」を「.NET Standard 2.1」から「.NET Framework」に変更します`,
                image: {
                    imageName: 'a7dba4de.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: `変更後画面を閉じます`,
            },
        ],
    },
    {
        contentsUuid: '50c4ebd7',
        level: '03',
        title: '「あつめて！すいかばマン」をダウンロードして環境設定をする',
        subTitle: '「あつめて！すいかばマン」をダウンロードして、Unityに読み込ませ、ゲーム画面を表示する設定をします。',
        titleColor: '#3759A9',
        backgroundColor: '#C7DB4D',
        tutorials: [
            {
                topic: 'あつめて！すいかばマンのUnityパッケージファイルをインポートします',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'Googleドライブにアクセスし「あつめて！すいかばマン.unitypackage」をダウンロードします',
                image: {
                    imageName: 'd04173b0.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: `Assets → Import Package → Custom Package でインポートファイルを選択する画面を開きます `,
                image: {
                    imageName: 'dc340c8d.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: `あつめて！すいかばマン.unitypackageを選択して開きます`,
                image: {
                    imageName: 'd0a3e4a6.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: `「import」をクリックしてAssetsに追加します`,
                image: {
                    imageName: '31af2d68.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#C7DB4D',
                title: `「Assets」にファイルが追加されていることを確認します`,
                image: {
                    imageName: 'be386bbb.png',
                },
            },
            {
                topic: 'あつめて！すいかばマンのゲーム画面表示を設定します',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: '「Scenes」を読み込みましょう。「Scenes」を選択し、「MainScene_A」をダブルクリックします',
                image: {
                    imageName: '1e794287.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: `保存（セーブ）を促す画面が表示されるので「Save」をクリックします`,
                image: {
                    imageName: 'f7444e86.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: `Gameタブに変更すると選択したScenesが表示されます`,
                image: {
                    imageName: '1c0cb0bb.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: `File → Build Settings → Add Open Scenes をクリックして選択したスクリーンを追加します`,
                image: {
                    imageName: '56aa0bc2.png',
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#C7DB4D',
                title: `「Add Open Scenes」をクリックして、選択したスクリーンが写っていることを確認します`,
                image: {
                    imageName: '7ff704f4.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 6,
                codeBackgroundColor: '#C7DB4D',
                title: `Buildへ残り5つのScenesも同様に追加します`,
                image: {
                    imageName: 'c6890f71.png',
                    widths: { base: 280, md: 820 },
                },
            },
            {
                code: 7,
                codeBackgroundColor: '#C7DB4D',
                title: `6つの「Scenes」が追加されていることを確認します（確認後、設定画面は閉じる）`,
                image: {
                    imageName: '821dfdbc.png',
                    widths: { base: 280, md: 820 },
                },
            },
        ],
    },
    {
        contentsUuid: '2dea77d7',
        level: '04',
        title: 'スクーミーボードとUnityを繋げて「あつめて！すいかばマン」を動かす',
        subTitle:
            'スクーミーボードとUnityを接続して、スクーミーボードを傾けてゲーム画面のキャラクターを動かせるようにします。',
        titleColor: '#3759A9',
        backgroundColor: '#C7DB4D',
        tutorials: [
            {
                topic: 'Unityで「SerialHandler」スクリプトを準備する',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'Assets → ScriptsでSerialHandlerをダブルクリックして開きます。中身を必要に応じて修正しましょう',
                image: {
                    imageName: '3c93a428.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: `ソースコードを修正します。portNameを、"COM3"のような形式にします (ボードを接続しているUSBポートにします。)`,
                image: {
                    imageName: '77055227.png',
                },
            },
            {
                topic: 'あつめて！すいかばマンをスタートします！',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: '「TitleScene」 が表示されている状態で、「▶」ボタンをクリックします。その後、ゲーム画面の「スタート」をクリックします',
                image: {
                    imageName: '052ca366.png',
                },
            },
            {
                topic: 'あつめて！すいかばマンをプレイします！',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'すいかが降っているので、スコミーボードを傾けてキャラクターを動かし、すいかをキャッチしましょう！',
                image: {
                    imageName: '667c76d7.png',
                },
            },
            {
                topic: 'あつめて！すいかばマンを停止します！',
                topicBackgroundColor: '#C7DB4D',
                topicTextColor: '#3759A9',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: '「▶」ボタンをクリックすると、ゲームが停止しスタート画面に戻る',
                image: {
                    imageName: '8671b09a.png',
                },
            },
        ],
    },
    {
        contentsUuid: '59f84a3b',
        level: '05',
        title: 'コネクターのプログラムを変えてみよう',
        subTitle: 'プログラムを組み変えて、角度センサーを違う方向軸に傾けてキャラクターを動かせるようにします。',
        titleColor: '#fdfeffff',
        backgroundColor: '#3bbde4ff',
        tutorials: [
            {
                topic: 'コネクターのプログラムと方向軸について',
                topicBackgroundColor: '#714e9cff',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: '手順書で作成したゲームはスクーミーボードを左右に傾ける（Y軸を変更させる）ことでキャラクターを動かして、アイテムをキャッチさせます。',
                image: {
                    imageName: '920be9fb.png',
                },
            },
            {
                topic: 'コネクターのプログラム',
                topicBackgroundColor: '#714e9cff',
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: 'シリアルモニターに「y」の値が表示されるブロックコードを使っています。',
                image: {
                    imageName: 'bc21543c.png',
                },
            },
            {
                topic: 'コネクターのプログラムの方向軸 (Y 軸、X 軸、Z 軸) について',
                topicBackgroundColor: '#714e9cff',
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: '変更するScriptsファイルを開きます',
                image: {
                    imageName: 'c3db78c9.png',
                },
            },
            {
                topic: 'X軸の傾きを変更しよう',
                topicBackgroundColor: '#714e9cff',
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'コネクターのプログラムをX軸の傾きを取得するように変更します。 スクーミーブロックエディタを起動させます。',
                image: {
                    imageName: '0b240172.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: '「アップロード」をクリックし、スクーミーボードにプログラムを書き込みます。',
                image: {
                    imageName: '45631b99.png',
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: 'シリアルモニターを表示させ「X」の値が表示されることを確認します。',
                image: {
                    imageName: '4abecf99.png',
                },
            },
            {
                topic: 'Z軸の傾きを変更しよう',
                topicBackgroundColor: '#714e9cff',
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: 'スクーミーブロックエディタで、Z軸の傾きを取得するように変更します。',
                image: {
                    imageName: 'b723e761.png',
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#C7DB4D',
                title: '「アップロード」をクリックし、スクーミーボードにプログラムを書き込みます。',
                image: {
                    imageName: 'db901d4c.png',
                },
            },
            {
                code: 6,
                codeBackgroundColor: '#C7DB4D',
                title: 'シリアルモニターを表示させ「z」の値が表示されることを確認します。',
                image: {
                    imageName: 'd66da034.png',
                },
            },
            {
                topic: '変更されたか確認しよう',
                topicBackgroundColor: '#714e9cff',
                code: 7,
                codeBackgroundColor: '#C7DB4D',
                title: '動作確認をしましょう。Unityを起動させて、「あつめて！すいかばマン」のプロジェクトをクリックします。',
                image: {
                    imageName: '0c8c34fd.png',
                },
            },
            {
                code: 8,
                codeBackgroundColor: '#C7DB4D',
                title: 'ゲームを実行させ、変更を確認します。Game画面を開き、「▶」ボタンをクリックし、コネクターを動かし、方向軸が変わっているか確認しましょう。',
                image: {
                    imageName: '2fb520bc.png',
                },
            },
        ],
    },
    {
        contentsUuid: 'd2d2c9f6',
        level: '06',
        title: '作ったゲームを遊んでもらえるようにしよう！',
        subTitle: 'スクーミーボードやゲーム画面の設定をして、つくったゲームがあそべるかどうか、動作確認をします。',
        titleColor: '#fdfeffff',
        backgroundColor: '#f19f3bff',
        tutorials: [
            {
                code: 1,
                codeBackgroundColor: '#C7DB4D',
                title: 'Unityを起動させて、「あつめて！すいかばマン」のプロジェクトをクリックします。',
                image: {
                    imageName: '2d08694c.png',
                },
            },
            {
                code: 2,
                codeBackgroundColor: '#C7DB4D',
                title: 'File → Build Settingsをクリックします。',
                image: {
                    imageName: '81ac95f7.png',
                },
            },
            {
                code: 3,
                codeBackgroundColor: '#C7DB4D',
                title: 'タイトル画面が初めに表示されるように、Scenes の順番を変更します。「TitleScene」を、ドラッグ＆ドロップで一番上に移動させます。',
                image: {
                    imageName: '8e81d2f4.png',
                    widths: { base: 280, md: 720 },
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#C7DB4D',
                title: '「TitleScene」が一番上になっていることを確認してください。',
                image: {
                    imageName: 'cbd68cd7.png',
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#C7DB4D',
                title: '「Player Settings」ボタンをクリックします。',
                image: {
                    imageName: '5198694d.png',
                    widths: { base: 280, md: 720 },
                },
            },
            {
                code: 6,
                codeBackgroundColor: '#C7DB4D',
                title: 'ゲーム情報を以下のように設定します。',
                image: {
                    imageName: 'ed4608ce.png',
                },
            },
            {
                code: 7,
                codeBackgroundColor: '#C7DB4D',
                title: 'Player設定画面の「×」ボタンをクリックして画面を閉じましょう。',
                image: {
                    imageName: 'e37b28f9.png',
                },
            },
            {
                code: 8,
                codeBackgroundColor: '#C7DB4D',
                title: 'Build Settings画面で実行環境の設定をします。以下の設定を反映させましょう。',
                image: {
                    imageName: 'b2f2cd93.png',
                    widths: { base: 280, md: 720 },
                },
            },
            {
                code: 9,
                codeBackgroundColor: '#C7DB4D',
                title: '実行ファイルを生成するため、「Build And Run」をクリックします。(動作確認を必要としない場合は「Build」をクリック)',
                image: {
                    imageName: '9de0eb2d.png',
                    widths: { base: 280, md: 720 },
                },
            },
            {
                code: 10,
                codeBackgroundColor: '#C7DB4D',
                title: '出力先のフォルダを作成します。複数のファイルが作成されるので「新しいフォルダー」をクリックして、空のフォルダを作成します。',
                image: {
                    imageName: 'e5a39feb.png',
                },
            },
            {
                code: 11,
                codeBackgroundColor: '#C7DB4D',
                title: 'フォルダの名前をゲーム名に変更して、フォルダをダブルクリックします。',
                image: {
                    imageName: 'b8143c6e.png',
                },
            },
            {
                code: 12,
                codeBackgroundColor: '#C7DB4D',
                title: 'フォルダの中身が空であることを確認して、「フォルダ選択」をクリックします。',
                image: {
                    imageName: '860eb43b.png',
                },
            },
            {
                code: 13,
                codeBackgroundColor: '#C7DB4D',
                title: 'ゲームの動作確認をしましょう。ゲーム画面が表示されるので「スタート」をクリックして、ゲームを開始します。',
                image: {
                    imageName: '042452a4.png',
                },
            },
            {
                code: 14,
                codeBackgroundColor: '#C7DB4D',
                title: 'スクーミーボードを傾けてアイテムをキャッチできるか確認してください。',
                image: {
                    imageName: '8565f1ab.png',
                },
            },
            {
                code: 15,
                codeBackgroundColor: '#C7DB4D',
                title: `ゲーム終了の動作確認もしましょう。 60秒待って、タイトル画面に戻り、「やめる」をクリックします。
                ※60 秒待たず、途中で終わりたい場合は「Alt+F4キー」でゲーム終了してください。`,
                image: {
                    imageName: '8d726494.png',
                },
            },
            {
                code: 16,
                codeBackgroundColor: '#C7DB4D',
                title: `配布用ゲーム資産の確認をします。 エクスプローラーで出力先のフォルダを確認し、以下の5つのファイルが作成されていることを確認してください。`,
                image: {
                    imageName: 'ebc4d9d6.png',
                },
            },
            {
                code: 17,
                codeBackgroundColor: '#C7DB4D',
                title: `別のPCに資産をコピーして、配布用のゲームを動かしてみましょう。「あつめて！すいかばマン .exe」をダブルクリックします。(.exeはPCの設定によっては表示されません)`,
                image: {
                    imageName: 'fa9cb868.png',
                },
            },
            {
                code: 18,
                codeBackgroundColor: '#C7DB4D',
                title: `配布用ゲームの動作確認をしましょう。ゲーム画面が表示されるので「スタート」をクリックして、ゲームを開始します。`,
                image: {
                    imageName: 'c1dc5ef5.png',
                },
            },
            {
                code: 19,
                codeBackgroundColor: '#C7DB4D',
                title: `補足：キャラクターが動かなかった場合、SerialHandlerを修正してみる。「SerialHandler」を開き「portName」を配布先のPCの環境に合わせて修正後、配布データ作成 (Build) を行いましょう。`,
                image: {
                    imageName: 'c8f12db6.png',
                },
            },
        ],
    },
];

export const BREADCRUMB_UNITY_GUIDE_ITEMS: Record<string, BreadcrumbItem[]> = {
    [BASE_URL]: [{ label: `${CONTENTSET_TITLE} 目次` }],
    ...Object.fromEntries(
        UNITY_GUIDE_DATA.map((item) => [
            `${BASE_URL}/${item.contentsUuid}`,
            [{ label: CONTENTSET_TITLE, href: BASE_URL }, { label: item.title }],
        ]),
    ),
};
